import Awesomplete from 'awesomplete';

function shuffle(array) {
  let currentIndex = array.length;
  let temporaryValue;
  let randomIndex;

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    temporaryValue = array[currentIndex];
    // eslint-disable-next-line no-param-reassign
    array[currentIndex] = array[randomIndex];
    // eslint-disable-next-line no-param-reassign
    array[randomIndex] = temporaryValue;
  }
  return array;
}

function mountPicker({ el = null }) {
  if (el === null) return false;

  const input = el.querySelector('input');
  const btnOpen = el.querySelector('[data-action="open-project-picker"]');

  input.value = '';

  const autocomplete = new Awesomplete(input, {
    minChars: 0,
    list: '#pick-a-project',
  });

  btnOpen.addEventListener('click', () => {
    if (autocomplete.ul.childNodes.length === 0) {
      autocomplete.minChars = 0;
      autocomplete.evaluate();
    } else if (autocomplete.ul.hasAttribute('hidden')) {
      autocomplete.open();
    } else {
      autocomplete.close();
    }
  });

  input.addEventListener('awesomplete-select', (e) => {
    e.preventDefault();
    window.location.assign(e.text.value);
  });

  return true;
}

async function mountHighlights({ root = null }) {
  if (root === null) return false;

  try {
    const res = await fetch('/wp-json/myrsky-theme/v1/get-random-projects/');
    const json = await res.json();

    if (json.posts_rendered) {
      const frag = document.createRange().createContextualFragment(json.posts_rendered);
      const cards = frag.querySelectorAll('.project-highlight__card');
      const shuffledIndexes = shuffle([0, 1, 2]);
      const shuffledNodeList = document.createElement('div');

      shuffledNodeList.classList.add('project-highlights');

      shuffledIndexes.forEach((i) => {
        if (cards.item(i)) {
          shuffledNodeList.appendChild(cards.item(i));
        }
      });

      root.replaceWith(shuffledNodeList);
    }
  } catch (error) {
    return true;
  }

  return true;
}

function mount({ rootElement = null }) {
  const picker = rootElement.querySelector('.project-highlights-picker');
  const highlights = rootElement.querySelector('.project-highlights');

  if (picker) {
    mountPicker({ el: picker });
  }

  if (highlights) {
    mountHighlights({ root: highlights });
  }
}

function init() {
  const blocks = document.querySelectorAll('.section--project-highlights');

  [...blocks].forEach((block) => {
    mount({ rootElement: block });
  });
}

export default init;
